module.exports = __webpack_public_path__ + "static/media/already-purchased-error.33b1394c.svg";